import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/(lang)/experts/components/ExpertsLayout.jsx");
